import store from '@/store/store'
import * as actions from '../store/actions/types'
import { router } from '@/router/router'

class Request {
  _silent = false
  _preventReload = false
  _options = {
    method: 'GET',
    headers: { Accept: 'application/json' }
  }

  _prepareOptions = (url, opts) => {
    const options = { ...this._options, ...opts }
    if (options.body && options.body instanceof FormData) {
      const tzOffset = -60 * (new Date()).getTimezoneOffset()
      options.body.append('_tz_offset', tzOffset)
    }

    if (options.query && typeof options.query === 'object') {
      const queryString = new URLSearchParams(options.query).toString()
      url += '?' + queryString
      delete options.query
    }

    return {
      url,
      options
    }
  }

  _prepareResponse = (response, profileCheck) => {
    if (!this._silent && !profileCheck) {
      this._handleErrors(response.status)
    }

    return response.json()
  }

  _showAlerts = (response) => {
    const notifications = []

    ;(response.errors || []).forEach(m => notifications.push({
      type: 'error',
      msg: m
    }))

    ;(response.warnings || []).forEach(m => notifications.push({
      type: 'warning',
      msg: m
    }))

    ;(response.info || []).forEach(m => notifications.push({
      type: 'info',
      msg: m
    }))

    ;(response.success || []).forEach(m => notifications.push({
      type: 'success',
      msg: m
    }))

    store.dispatch(actions.CREATE_NOTIFICATIONS, notifications)
  }

  _handleErrors = (code) => {
    const ERROR_CODE_FORBIDDEN = 403
    const ERROR_CODE_UNAUTHORIZED = 401

    if (code === ERROR_CODE_FORBIDDEN || code === ERROR_CODE_UNAUTHORIZED) {
      setTimeout(() => {
        if (!this._preventReload) {
          location.reload()
        }
      }, 10 * 1000)
    }
  }

  _handleResponse = async (response, profileCheck, options, params) => {
    if (response instanceof Error) {
      response = {
        errors: ['Что-то пошло не так, попробуйте попозже.']
      }
    }

    this._showAlerts(response)

    if (profileCheck) {
      if (response.errors && response.errors[0].includes('Заполните в своём профиле')) {
        const _current = await router.history?.current || {}
        const sessionID = _current.params?.sessionID || params.sessionID
        const _orderID = options.body instanceof FormData ? options.body.get('order') : null
        const _from = sessionID ? '' : window.location.pathname

        const userID = store.getters?.ACCOUNT?.id
        router.push({ name: 'user-required-fields', params: { userID }, query: { _from, _orderID, sessionID } }).catch(() => {})
      }
    }

    if (response.errors) {
      if (response.errors[0].includes('Примите политику обработки')) {
        this._preventReload = true
        router.push({ name: 'privacy-policy' })
        return
      }

      if (response.errors[0].includes('Примите условия работы с документами с ПЭП')) {
        this._preventReload = true
        router.push({ name: 'signed-files-policy' })
        return
      }

      // signed-files-policy
    }

    if (response.errors) {
      throw new Error(response.errors[0])
    }

    return response
  }

  do = (initialUrl, opts, silent = false, profileCheck = false, params = {}) => {
    const { url, options } = this._prepareOptions(initialUrl, opts)
    this._silent = silent

    return fetch(url, options)
      .then(res => this._prepareResponse(res, profileCheck))
      .catch(err => this._handleResponse(err, profileCheck, options, params))
      .then(res => this._handleResponse(res, profileCheck, options, params))
  }
}

export const request = new Request().do
